// @ts-nocheck

import { mapValues as _mapValues, keyBy as _keyBy } from 'lodash';

const basketReceiveBoosters = (state, action) => {
  const { data: nextBoosters } = action.payload;
  const { boosters } = state;
  const prevBoosters = _mapValues(boosters, (booster) => ({
    ...booster,
    deleted: true,
  }));
  const nextBoostersById = _keyBy(nextBoosters, 'boosterId');
  const finalBoosters = { ...prevBoosters, ...nextBoostersById };
  return {
    ...state,
    boosters: finalBoosters,
  };
};

export default basketReceiveBoosters;
